import { render, staticRenderFns } from "./overlay_id_select.vue?vue&type=template&id=5aac2c24&lang=pug&"
import script from "./overlay_id_select.vue?vue&type=script&lang=js&"
export * from "./overlay_id_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports